import { useGetProfileQuery } from '@api/front-office/profile.api.rtk';
import ServerError from '@components/animation/server-error';
import DataTable from '@components/table/datatable';
import useMenu from '@hooks/useMenu';
import { ProfileDetailsList } from '@modules/front-office/interface/fo-profile-interface';
import { IPOSTableDetailsFormSchema } from '@modules/point-of-sale/interface/table-details.interface';
import { Button, Stack, SxProps } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useAppSelector } from '@store/index';
import { useFormContext } from 'react-hook-form';

const POSTaxPayerIndividualDatatable = ({
  onClose,
}: {
  onClose: () => void;
  sx?: SxProps;
}) => {
  //#region useMenu
  const { handleContextMenu, handleTouchEnd, handleTouchStart } = useMenu();
  //#endregion useMenu

  const { setValue } = useFormContext<IPOSTableDetailsFormSchema>();

  //region useAppSelector
  const selectedProperty = useAppSelector(
    (state) => state.properties.selectedProperty,
  );
  //#endregion useAppSelector

  //region useGetProfileQuery
  const {
    data: profileList,
    isError,
    isLoading,
    isFetching,
  } = useGetProfileQuery(`?filter[accountType]=Individual`, {
    skip: selectedProperty.value === 'All Properties',
  });
  //#endregion useGetProfileQuery

  //region DataTableColumns
  const DataTableColumns: GridColDef[] = [
    {
      field: 'accountName',
      headerName: 'Business Name',
      flex: 1,
      hideable: false,
      sortable: false,
    },
    {
      field: 'tinNo',
      headerName: 'TIN No.',
      flex: 1,
      hideable: false,
    },
    {
      field: 'taxBusStyle',
      headerName: 'Business type',
      flex: 1,
      hideable: false,
    },
    {
      field: 'address',
      headerName: 'Address',
      flex: 1,
      hideable: false,
    },
  ];
  //endregion DataTableColumns

  const profileDetailedList: ProfileDetailsList[] = (
    profileList?.data?.profiles ?? []
  ).map((profileWrapper) => profileWrapper.profiles);

  return (
    <>
      {isError ? (
        <ServerError />
      ) : (
        <>
          <DataTable
            columns={DataTableColumns}
            getRowId={(row) => row.profileID}
            loading={isFetching || isLoading}
            rows={isError ? [] : profileDetailedList || []}
            pageSize={10}
            disableAdditionalLoading={true}
            checkboxSelection={false}
            tableStyle={{
              flex: 1,
              '&.MuiDataGrid-root': {
                p: 0,
              },
              '.MuiDataGrid-cell': {
                whiteSpace: 'unset !important',
                maxHeight: 'unset !important',
              },

              '& .used': {
                pointerEvents: 'none',
                cursor: 'not-allowed',
              },
            }}
            slotProps={{
              row: {
                onContextMenu: handleContextMenu,
                onTouchStart: handleTouchStart,
                onTouchEnd: handleTouchEnd,
                style: { cursor: 'context-menu' },
              },
            }}
            fullHeight
            onRowClick={(params) => {
              setValue('busName', params.row.accountName);
              setValue('taxTIN', params.row.tinNo);
              setValue('busType', params.row.taxBusStyle);
              setValue('homeAddress', params.row.address);
              onClose();
            }}
          />

          <Stack
            sx={{
              justifyContent: 'flex-end',
            }}
            direction={{ xs: 'column', lg: 'row' }}
          >
            <Stack
              sx={{
                p: 2,
                gap: { xs: 2, sm: 1 },
                justifyContent: 'flex-end',
              }}
              direction={{ xs: 'column', md: 'row' }}
            >
              <Button variant='outlined' sx={{ px: 4 }} onClick={onClose}>
                Close
              </Button>
            </Stack>
          </Stack>
        </>
      )}

      {/* <MenuWrapper>
        <MenuItem
          onClick={() => {
            // addTableAreaDisclosure.onOpen();
            onClose();
            handleClose();
          }}
        >
          Use This Tax Payer
        </MenuItem>
      </MenuWrapper> */}
    </>
  );
};

export default POSTaxPayerIndividualDatatable;
